import { rem } from '../../../utils/rem';
export var MuiListItemAvatar = {
    styleOverrides: {
        root: {
            minWidth: rem(40),
        },
    },
};
